module.exports = __webpack_public_path__ + "static/img/2-0-aftersale-fast.dc0b9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-0-aftersale-fast.png
// module id = 1311
// module chunks = 0